import { render, staticRenderFns } from "./ClothesSizesPdf.vue?vue&type=template&id=498da548&"
import script from "./ClothesSizesPdf.vue?vue&type=script&lang=js&"
export * from "./ClothesSizesPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports